<div class="research-question-item" [class.disabled]="disabled">
    <label class="research-question-text">
      <input type="checkbox" [checked]="checked" [disabled]="disabled" (change)="onToggle($event)"/>
      {{ question.mainQuestion }}</label>
</div>
